/// <reference path="../../_ext/Bases/GridBase.ts" />
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class DesignBOMGrid extends _Ext.GridBase<DesignBOMRow, any> {
        protected getColumnsKey() { return 'OMS.DesignBOM'; }
        protected getDialogType() { return DesignBOMDialog; }
        protected getIdProperty() { return DesignBOMRow.idProperty; }
        protected getLocalTextPrefix() { return DesignBOMRow.localTextPrefix; }
        protected getService() { return DesignBOMService.baseUrl; }
        protected get_ExtGridOptions() { return Q.deepClone(q.DefaultMainGridOptions) }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            //if (!this.hasInsertPermission || this.readOnly) {
            //    this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            //}
        }

        //protected onClick(e: JQueryEventObject, row: number, cell: number) {
        //    super.onClick(e, row, cell);

        //    if (e.isDefaultPrevented())
        //        return;

        //    var item = this.itemAt(row);
        //    var target = $(e.target);

        //    // if user clicks "i" element, e.g. icon
        //    if (target.parent().hasClass('inline-action'))
        //        target = target.parent();
        //    /*
        //    if (target.hasClass('inline-action')) {
        //        e.preventDefault();

        //        if (target.hasClass('print-invoice')) {
        //            Admin.Common.ReportHelper.execute({
        //                reportKey: 'Northwind.OrderDetail',
        //                params: {
        //                    OrderID: item.OrderID
        //                }
        //            });
        //        }
        //    }*/
        //}
    }
}